const prefix = '@@billing';

export const BillingActionTypes = {
    API_RESPONSE_SUCCESS: `${prefix}/API_RESPONSE_SUCCESS`,
    API_RESPONSE_ERROR: `${prefix}/API_RESPONSE_ERROR`,

    LOAD_PAYMENT_METHODS: `${prefix}/LOAD_PAYMENT_METHODS`,
};
